import React, { useMemo, useState } from 'react'
import useDataFetcher from '../../../knisot/hooks/useFetchData'
import { TEUDOT_PROBLEMS } from '../../../../../../modules/API/TeudotProblems/teudotProblems'
import { format } from 'date-fns'
import { useDispatch } from 'react-redux'
import { LOAD, LOAD_END } from '../../../../../../../store/actions/actionsTypes'
import { IReportTable } from '../types/table'
import { handleNotifications } from '../../../../../../generic/utils/handleNotifications'
import { ISellerResponse } from '../../../../../../modules/API/Defaults/models/seller'
import { Defaults } from '../../../../../../modules/API/Defaults/defaults'
import { IProblemListItem } from '../../../../../../modules/API/TeudotProblems/models/problems'
import { IClientsItem, IClientsItemResponse } from '../../../../../../modules/API/Defaults/models/customers'
import { IProductListNodeResponse } from '../../../../../../modules/API/Defaults/models/productListNode'



const useReportServices = () => {
  const dispatch = useDispatch()
  const [date, setDate] = useState<Date[]>([new Date(), new Date()])
  const [search, setSearch] = useState<string>('')
  const [reportsData, setReportsData] = useState<IReportTable | null>(null)
  const [selectedSeller, setSelectedSeller] = useState<number>(0)
  const [selectedProblemType, setSelectedProblemType] = useState<number>(0)
  const [selectedCustomer, setSelectedCustomer] = useState<number>(0)
  const [selectedGroupBy, setSelectedGroupBy] = useState<number>(0)
  const [selectedProduct, setSelectedProduct] = useState<number>(0)
  const [isOpenFilterModal, setIsOpenFilterModal] = useState<boolean>(true)
  
  const { 
    data: sellerList 
  } = useDataFetcher<ISellerResponse>(
    Defaults.getSellerList,
    "data"
  )
  const {
    data: problemTypeList
  } = useDataFetcher<IProblemListItem[]>(
    TEUDOT_PROBLEMS.getProblemList,
    "data"
  )
  const {
    data: customerList
  } = useDataFetcher<IClientsItemResponse>(
    Defaults.getCustomers,
    "data"
  )
  const {
    data: productList
  } = useDataFetcher<IProductListNodeResponse>(
    Defaults.getProductsList,
    "data"
  )

  const isAllowToFetchForReports = () => {
    return selectedGroupBy !== 0
  }
  const handleGetReports = async () => {
    dispatch({type: LOAD})
    if(!isAllowToFetchForReports()) {
      handleNotifications("יש לבחור מיון", {type: "warning"})
      return
    }
    try {
      const data = await TEUDOT_PROBLEMS.getReports(`DateFrom=${format(date[0], 'yyyyMMdd')}&DateTo=${format(date[1], 'yyyyMMdd')}&GroupBy=${selectedGroupBy}&ProblemType=${selectedProblemType}&SellerID=${selectedSeller}&CustomerID=${selectedCustomer}&ProductID=${selectedProduct}`)
      setReportsData(data)
      setIsOpenFilterModal(false)
    } catch (error) {
      console.log(error)
    } finally {
      dispatch({type: LOAD_END})
    }
  }
 
  const handleModalFilter = () => {
    setIsOpenFilterModal(!isOpenFilterModal)
  }

  const dashboardData = useMemo(() => {
    return reportsData
  }, [reportsData])
    return (
      {
        date,
        setDate,
        dashboardData,
        search,
        setSearch,
        handleGetReports,
        selectedSeller,
        setSelectedSeller,
        selectedProblemType,
        setSelectedProblemType,
        selectedCustomer,
        setSelectedCustomer,
        selectedGroupBy,
        setSelectedGroupBy,
        selectedProduct,
        setSelectedProduct,
        isOpenFilterModal,
        handleModalFilter,
        sellerList: sellerList?.sellers || [],
        problemTypeList: problemTypeList || [],
        customerList: customerList?.customers || [],
        productList: productList?.products || [],
        isAllowToFetchForReports,
      }
    )
}

export default useReportServices